module.exports = __webpack_public_path__ + "static/media/bank.5af24414.svg";